module.exports = "https://coursera_assets.s3.amazonaws.com/images/c0d7fb55f62de0c30e4469d8c5120d6d.png";